import React from "react";
import PropTypes from "prop-types";
import "./HeaderDetalle.css";
import { Button, Col, Row, Label } from "react-bootstrap";
import lstrings from "../../utils/LStrings";
import ScoreWidget from "../../scenes/personas/components/personas-detalle/components/ScoreWidget";
import TableUtils from "../../utils/TableUtils";
import { PERMISO_RESTRINGIDO } from "../../config";

import Session from "../../utils/Session";
class HeaderDetalle extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      consultasPrevias: false,
      score: null,
      scorePuntaje: null,
      showIncome: false,
      showVerazLogo: false,
      showVariables: true,
    };
  }

  componentDidMount() {
    if (
      this.props.consultasPorRubro &&
      this.props.consultasPorRubro.totalConsultas > 0
    ) {
      this.setState({ consultasPrevias: true });
    }

    if (this.props.status == PERMISO_RESTRINGIDO) {
      this.setState({ showVariables: false });
    }

    const dt = this.props.datosParticulares;
    if (dt) {
      if (dt.scoreAgdEnabled) {
        this.setState({
          showScore: true,
          score: dt.score,
          scorePuntaje: dt.puntaje,
        });
      }
    }
  }

  render() {
    return (
      <Row>
        <Col sm={7}>
          <h1>{this.props.nombre}</h1>

          <h3>
            <strong>CUIT/CUIL: </strong>
            {this.props.cuil}
          </h3>

          {this.props.datosParticulares &&
            this.props.datosParticulares.sujetoObligado &&
            this.props.datosParticulares.sujetoObligado.habilitado && (
              <h4 title={this.props.datosParticulares.sujetoObligado.mensaje}>
                <Label bsStyle="success">{lstrings.sujetoObligado}</Label>
              </h4>
            )}

          {this.props.consultasPorRubro && (
            <div>
              <b>Cantidad de consultas: </b>
              <span>{this.props.consultasPorRubro.totalConsultas}</span>
            </div>
          )}
          {this.state.consultasPrevias && (
            <div>
              <div>
                {this.props.consultasPorRubro.consultas.map((elem) => (
                  <span className="rubroConsulta" key={elem.rubro}>
                    <b>{elem.rubro}: </b>
                    <span>{elem.cantidadConsultas}</span>
                  </span>
                ))}
              </div>

              <div>
                <b>Fecha de última consulta: </b>
                <span>
                  {TableUtils.dateFormatHs(
                    this.props.consultasPorRubro.fechaUltimaConsulta
                  )}{" "}
                </span>
                <span>
                  consultado por (
                  {this.props.consultasPorRubro.rubroUltimaConsulta})
                </span>
              </div>
            </div>
          )}
        </Col>

        <Col sm={5}>
          <div className="pull-right">
            <div
              style={{
                marginTop: "3em",
                display: "flex",
              }}
            >
              <div
                style={{
                  borderRight: "1px solid rgba(0,0,0,0.2)",
                  paddingRight: "2rem",
                  minWidth: "170px",
                  position: "relative",
                }}
              >
                {this.state.showScore && (
                  <ScoreWidget
                    score={this.state.score}
                    puntaje={this.state.scorePuntaje}
                  />
                )}
              </div>

              <div
                style={{
                  paddingLeft: "1rem",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  alignItems: "flex-end",
                  minHeight: "100px",
                }}
              >
                {this.state.showVariables && (
                  <h3 style={{ margin: 0 }}>
                    <strong>Status: </strong>
                    {this.props.status || "-"}&nbsp;
                    <a onClick={this.props.onStatusDialogShow}>
                      <i className="fa fa-search"></i>
                    </a>
                  </h3>
                )}
                {this.props.enablePrint && (
                  <div>
                    <Button onClick={this.props.onPrint}>
                      <i className="fa fa-print"></i>
                    </Button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </Col>
      </Row>
    );
  }
}

HeaderDetalle.propTypes = {
  nombre: PropTypes.string,
  cuil: PropTypes.string,
  datosParticulares: PropTypes.any,
  consultasPorRubro: PropTypes.any,
  status: PropTypes.string,
  onStatusDialogShow: PropTypes.func,
  onPrint: PropTypes.func,
  enablePrint: PropTypes.bool,
};

export default HeaderDetalle;



// WEBPACK FOOTER //
// ./src/components/header-detalle/HeaderDetalle.js